module.exports = __webpack_public_path__ + "static/media/cauliflowertacos.01dd00ae.jpg";